const NAME = "ISSUE_SUMMARY";

export default NAME;
